import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'mc-drawer-back-button',
  templateUrl: './drawer-back-button.component.html',
  styleUrls: ['./drawer-back-button.component.scss'],
})
export class DrawerBackButtonComponent {
  @Output() clickEvent = new EventEmitter();
}
